import { SearchInput } from '../shared';
import { SortOrder, OfficeEquipmentModelSortType } from '../enums';

export class GetOfficeEquipmentModelsInput extends SearchInput<OfficeEquipmentModelSortType> {
    public officeEquipmentBrandId: number | null = null;
    public officeEquipmentTypeId: number | null = null;

    constructor() {
        super(OfficeEquipmentModelSortType.Name);
        this.sortOrder = SortOrder.Ascending;
    }
}
